import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import {AzPageHeader} from '../../components/AzPageHeader'
import { FacilitiesListWrapper } from './facilities-list/FacilitiesList';
import { useIntl } from 'react-intl';

const FacilityPage = () => {
  const intl = useIntl();

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='facilities'
          element={
            <>
              <AzPageHeader title={intl.formatMessage({ id: 'FACILITY_PAGE.TITLE' })} />
              <FacilitiesListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/facility-management/facilities' />} />
    </Routes>
  );
};

export default FacilityPage;